export default __webpack_public_path__ + "static/light-blue-88df16fc8b49d3881dac9c395138862b.png";